<h2 i18n [class.title-white]="title.isSpecial">{{ title.text }}</h2>
<div class="sides">
    @for (side of sides; track side) {
    <div class="side side-{{ side.position }} state-{{ side.state }}">
        @for (hand of side.hands; track hand) {
        <div class="hand state-{{ hand.state }}">
            <div class="hand-content">
                <div class="hand-amount">@if (hand.amount.visible) { {{ hand.amount.value }} }</div>
                <div class="cards">
                    @for (card of hand.cards; track card; let cardIndex = $index) {
                    <app-card-holder [card]="cards[card.position]" [rotated]="card.isRotated" [compact]="card.isCompact"></app-card-holder>
                    }
                </div>
                <!-- We need `data-text` for the text shadow -->
                <div i18n class="hand-title" [attr.data-text]="hand.label" i18n-data-text>{{ hand.label }}</div>
            </div>
        </div>
        }
    </div>
    }
</div>
